import { render, staticRenderFns } from "./Column.vue?vue&type=template&id=735693e8&"
import script from "./Column.vue?vue&type=script&lang=js&"
export * from "./Column.vue?vue&type=script&lang=js&"
import style0 from "./Column.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../data/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('735693e8')) {
      api.createRecord('735693e8', component.options)
    } else {
      api.reload('735693e8', component.options)
    }
    module.hot.accept("./Column.vue?vue&type=template&id=735693e8&", function () {
      api.rerender('735693e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/Charts/Layouts/ReportSection/Column.vue"
export default component.exports